import React from "react";
import "./CarRental.css";
import { FaCar } from "react-icons/fa";

function CarRental() {
  return (
    <div className="car-rental-page">
      <div className="content-card">
        <FaCar className="car-icon" />
        <h1>Car Rental</h1>
        <h3>Coming Soon!</h3>
        <p>
          We’re working hard to launch our premium car rental services. Stay tuned for updates!
        </p>
        <button className="notify-btn">Notify Me</button>
      </div>
    </div>
  );
}

export default CarRental;
